module.exports = __webpack_public_path__ + "img/cns_pc26.9db19769.png";